<template>
  <div class="pt-19">
    <div class="th-notification-table-main-container">
      <table class="tableBg2 create-edit-packet-page__order-table th-notification-table" cellspacing="0" cellpadding="0" border="0">
        <colgroup>
          <col style="width: 100%" />
        </colgroup>
        <thead class="fixedHeader">
          <tr class="th-notification-user-table-header">
            <th class="pl-16 input_check_box">
              <div class="input-group">
                <input type="checkbox" v-model="isAllSelected" @change="onSelectAllUser" aria-label="Checkbox for following text input" />
              </div>
            </th>
            <th class="p-0 cursor-pointer nameth">
              Name
              <span class="sortUp" @click="onSortUserData('firstName', 'ASC')">
                <i class="fa fa-angle-up" aria-hidden="true"></i>
              </span>
              <span class="user-sort-down" @click="onSortUserData('firstName', 'DESC')">
                <i class="fa fa-angle-down" aria-hidden="true"></i>
              </span>
            </th>

            <th class="p-0 pl-1 cursor-pointer roleth">
              Role
              <span class="sortUp" @click="onSortUserData('userRole', 'ASC')">
                <i class="fa fa-angle-up" aria-hidden="true"></i>
              </span>
              <span class="user-sort-down" @click="onSortUserData('userRole', 'DESC')">
                <i class="fa fa-angle-down" aria-hidden="true"></i>
              </span>
            </th>
            <template>
              <th class="pl-80">Email</th>
              <th class="pl-34">SMS</th>
            </template>
          </tr>
        </thead>
        <tbody class="scrolldown">
          <tr v-for="(user, index) in userList" :key="index" :id="'selected-' + user.id" class="mb-10">
            <td>
              <div class="input-group checkbox-td">
                <input type="checkbox" aria-label="Checkbox for following text input" v-model="selectedTeam" :value="user" @change="onUserChange" />
              </div>
            </td>
            <td class="user-name-label activity_type mt-7 p-0">
              <b class="nametd"> {{ user.firstName }} {{ user.lastName }} </b>
            </td>
            <td class="form-text activity_type mt-7 p-0 roletd">
              <span class="user-role-label">{{ userRole[user.userRole] }}</span>
            </td>
            <template>
              <td class="p-0 email_switch email_switch_td">
                <div class="d-flex col-md-4 pl-0">
                  <span class="setting-btn-text">Off</span>
                  <div class="d-flex">
                    <label class="switch mb-0">
                      <input type="checkbox" v-model="user.isEmail" @change="onUserChange" />
                      <div class="slider round" tabindex="15"></div>
                    </label>
                    <span class="setting-btn-text">On</span>
                  </div>
                </div>
              </td>
              <td class="p-0 email_switch_td">
                <div class="d-flex col-md-4 pl-0">
                  <span class="setting-btn-text">Off</span>
                  <div class="d-flex">
                    <label class="switch mb-0">
                      <input type="checkbox" v-model="user.isMobile" @change="onUserChange" />
                      <div class="slider round" tabindex="15"></div>
                    </label>
                    <span class="setting-btn-text">On</span>
                  </div>
                </div>
              </td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectedTeam: [],
      isAllSelected: false,
      userRole: {
        Pi: "Principal Investigator",
        SubPi: "Sub-Investigator",
        StudyCoordinator: "Study Coordinator",
        HomeHealth: "Home Health",
        SiteDataLock: "Site - Data Lock",
        Cra: "Clinical Research Associate (Blinded)",
        CraUB: "Clinical Research Associate (Unblinded)",
        Dm: "Data Management",
        Quality: "Quality"
      }
    };
  },
  props: {
    userList: {
      type: Array
    },
    selectedUserList: {
      type: Array,
      default: () => []
    }
  },
  async mounted() {
    await this.getFilterUserList();
  },
  methods: {
    getFilterUserList() {
      this.userList &&
        this.userList.filter(user => {
          this.selectedUserList &&
            this.selectedUserList.filter(selectedUser => {
              if (user.id === selectedUser.id) {
                this.selectedTeam.push(user);
              }
            });
        });
      if ((this.selectedTeam && this.selectedTeam.length) === (this.userList && this.userList.length)) {
        this.isAllSelected = true;
      }
    },
    onUserChange() {
      this.$emit("onSelectUserChange", this.selectedTeam);
    },
    onSelectAllUser() {
      this.selectedTeam = [];
      this.selectedTeam = this.isAllSelected ? this.userList : [];
      this.$emit("onSelectUserChange", this.selectedTeam);
    },
    onSortUserData(columnName, order) {
      const columnType = "string";
      if (columnType == "string") {
        this.sortByString(columnName, order);
      }
      this.$forceUpdate();
    },
    sortByString(columnName, order) {
      if (order == "ASC") {
        this.userList.sort((a, b) => {
          const nameA = a[columnName] && a[columnName].toLowerCase();

          const nameB = b[columnName] && b[columnName].toLowerCase();
          if (nameA < nameB) {
            //sort string ascending
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      } else {
        this.userList.sort((a, b) => {
          const nameA = a[columnName] && a[columnName].toLowerCase();

          const nameB = b[columnName] && b[columnName].toLowerCase();
          if (nameA < nameB) {
            return 1;
          }
          if (nameA > nameB) {
            return -1;
          }
          return 0;
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.user-name-label {
  font-size: 13px;
  font-weight: 500;
  color: #000;
  width: 168px;
}
.user-role-label {
  font-size: 14px;
  color: #000000;
}
.th-notification-table-main-container {
  border: solid 1px #b0bac9;
  border-radius: 4px;
  border-top: 0px;
}
.th-notification-table {
  width: 100% !important;
}
table.scrolldown tbody {
  height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.sortUp {
  position: absolute;
  margin-top: -3px;
  padding-left: 4px;
  width: 0;
  height: 0;
  background: transparent;
  border-top-width: 0;
  cursor: pointer;
}
.user-sort-down {
  position: relative;
  padding-left: 4px;
  width: 0;
  height: 0;
  cursor: pointer;
  top: 4px;
  z-index: 1;
}
table thead {
  height: 26px;
  width: 100.2%;
  padding: 5px 5px 1px 16px;
  border-radius: 4px;
  background-color: rgba(176, 186, 201, 0.5);
  border-bottom: solid 1px #b0bac9;
  border-top: solid 1px #b0bac9;
  border-radius: 4px;
}
table tbody {
  width: 100%;
  padding: 5px 5px 7px 16px;
}
.th-notification-user-table-header {
  height: 26px;
  padding: 3px 0px;
}
thead.fixedHeader tr {
  display: block;
}
table td {
  font-size: 14px;
}
table td {
  padding: 8px 0;
}
.scrolldown {
  width: 100%;
  height: 225px;
  border-collapse: collapse;
  background-color: rgba(211, 222, 227, 0.3);
  overflow-y: auto;
  overflow-x: hidden;
  display: block;
}
thead.fixedHeader th {
  width: 188px;
}
table .input_check_box,
table .input-group {
  width: 35px !important;
}
table .nameth {
  width: 226px !important;
}
table .roleth {
  width: 120px !important;
}
table .email_switch {
  width: 132px;
}

// fixed width for for tbody
table .checkbox-td {
  width: 35px !important;
}
table .nametd {
  width: 130px !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
table .roletd {
  width: 145px !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 15px !important;
}
table .email_switch_td {
  width: 132px;
}
/* To display the block as level element */
table.scrolldown tbody,
table.scrolldown thead {
  display: block;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: rgba(211, 222, 227, 0.3);
}

::-webkit-scrollbar-thumb {
  background-color: #b0bac9;
  border-radius: 10px;
}
</style>
